import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import { transformTask } from '@/utils/tasks'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'
import { closeTaskResult } from '@/enums/closeTaskResult'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators as myActiveTaskActions } from '@/store/myActiveTask'
import { dialogTypes } from '@/dialogs'
import { allowErrorDialog } from '@/utils/fetch'
import { openErrorDialog } from '@/utils/dialogHelpers'

export const initialState = {
  task: null,
  retrieving: false,
  closing: false,
  descriptionUpdating: false,
  detailComponentKey: getComponentKey(),
  gridKey: getComponentKey()
}

export const actionTypes = {
  updateResultData: 'tasks/updateResultData',
  updateStartTime: 'tasks/updateStartTime',

  fetching: 'myTasks/fetching',
  fetched: 'myTasks/fetched',
  error: 'myTasks/error',

  attachmentsUpdated: 'myTasks/AttachmentsUpdated',
  assignedToUpdated: 'myTasks/AssignedToUpdated',
  refresh: 'myTasks/refresh',

  closing: 'myTasks/closing',
  closed: 'myTasks/Closed',

  descriptionUpdating: 'myTasks/descriptionUpdating',
  descriptionUpdated: 'myTasks/descriptionUpdated'
}

export const actionCreators = {
  getMyTask: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching, data: id })
    context.api.taskService.getMyTask(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: transformTask(response) })
        dispatch(myActiveTaskActions.getMyActiveTask())
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { retrieving: false } }))
  },
  updateAssignedTo: (id, { makerUser }) => (dispatch) => {
    context.api.taskService.updateAssignedTo({ id, assignedToUserId: makerUser.id }, allowErrorDialog)
      .then(response => {
        if (response) {
          const data = { id, ...{ assignedTo: makerUser.name, assignedToUserId: makerUser.id } }
          dispatch({ type: actionTypes.assignedToUpdated, data })
          dispatch(actionCreators.getMyTask(id))
          dispatch(myActiveTaskActions.getMyActiveTask())
        }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { detailComponentKey: getComponentKey() } }))
  },
  updateAttachments: (id, attachments) => (dispatch) => {
    context.api.taskService.updateAttachments({ id, attachments: attachments.map(x => x.id) }, allowErrorDialog)
      .then(response => {
        if (response) {
          dispatch({ type: actionTypes.attachmentsUpdated, data: { id, attachments } })
        }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { detailComponentKey: getComponentKey() } }))
  },
  closeTask: (id, result) => (dispatch) => {
    const callCloseTaskApi = ({ id, result, ignoreNoChanges = false }) => {
      dispatch({ type: actionTypes.closing })
      context.api.taskService.closeTask({ id, result, ignoreNoChanges }, allowErrorDialog)
        .then(response => {
          if (response === closeTaskResult.enum.Success) {
            dispatch({ type: actionTypes.closed, data: { id, status: workflowTaskStatus.enum.Closed } })
            dispatch(actionCreators.getMyTask(id))
          } else if (response === closeTaskResult.enum.NoChanges) {
            dispatch({ type: actionTypes.error, update: { closing: false } })
            if (!ignoreNoChanges) {
              dispatch(dialogActions.openDialog({
                dialogType: dialogTypes.confirm,
                title: 'Common.Confirmation',
                content: 'Tasks.NoChangeConfirmationText',
                onAction: () => callCloseTaskApi({ id, result, ignoreNoChanges: true })
              }))
            }
          } else throw new Error('Close Task Response was not \'Success\'')
        })
        .catch(() => {
          dispatch({ type: actionTypes.error, update: { closing: false, error: true } })
          openErrorDialog({ customErrorText: 'Tasks.CloseFailed' })
        })
    }

    callCloseTaskApi({ id, result, ignoreNoChanges: false })
  },
  updateDescription: (request) => (dispatch) => {
    dispatch({ type: actionTypes.descriptionUpdating })
    context.api.taskService.updateDescription(request, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.descriptionUpdated, data: request })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { descriptionUpdating: false } }))
  },
  updateStartTime: ({ id, startTime }) => ({ type: actionTypes.updateStartTime, data: { id, startTime } }),
  updateResultData: ({ id, data }) => ({ type: actionTypes.updateResultData, data: { id, result: data } }),
  refresh: () => ({ type: actionTypes.refresh })
}

// updates state and if 'id' matches current task.id, updates task as well
const updateState = (state, update, { id, updateTask }) => {
  return {
    ...state,
    ...update,
    task: (state.task && state.task.id === id ? { ...state.task, ...updateTask } : state.task)
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, retrieving: true }
    case actionTypes.fetched: return { ...state, retrieving: false, detailComponentKey: getComponentKey(), task: action.data }
    case actionTypes.error: return { ...state, ...action.update }

    case actionTypes.closing: return { ...state, closing: true }
    case actionTypes.closed: return updateState(state, { closing: false }, { id: action.data.id, updateTask: action.data })

    case actionTypes.descriptionUpdating: return { ...state, descriptionUpdating: true }
    case actionTypes.descriptionUpdated: return updateState(state, { descriptionUpdating: false }, { id: action.data.id, updateTask: action.data })

    case actionTypes.attachmentsUpdated: return updateState(state, null, { id: action.data.id, updateTask: action.data })
    case actionTypes.assignedToUpdated: return updateState(state, null, { id: action.data.id, updateTask: action.data })
    case actionTypes.updateResultData: return updateState(state, null, { id: action.data.id, updateTask: action.data })
    case actionTypes.refresh: return { ...state, detailComponentKey: getComponentKey(), gridKey: getComponentKey() }
    case actionTypes.updateStartTime: return updateState(state, null, { id: action.data.id, updateTask: action.data })
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/myTasks.js